<template>
  <div class="page-template add-page" v-loading="loading">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit(3)" type="primary" plain :disabled="formModel.reviewerStatus === null">审核</el-button>
      <el-button @click="supplierChange" type="primary" plain>采购查询</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form
      v-show="complexShow"
      ref="listOperationForm"
      :formOptions="listFormOptions"
      @valueChange="listFormValueChange">
    </list-operation-form>
    <list-operation ref="listOperation" :tableOptions="listColumns"
                    @selectRowChange="selectShowChange"></list-operation>
  </div>
</template>
<script>
  //添加要货单组件
  import listOperation from "@/components/template/listOperation";
  //要货单搜索组件
  import listOperationForm from "@/components/template/listOperationForm";
  import api from "@/config/api";

  export default {
    components: {
      listOperation,
      listOperationForm,
    },
    data() {
      return {
        complexShow: true,
        isExistNullPrince: 0,
        formModel: {reviewerStatus: null},
        loading: false,
        title: "",
        listShow: false,
        dialogShow: false,
        //头部条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: "reviewerStatus",
            statusImg: {
              10: "/static/checked.png",
              20: "/static/un-check.png",
            },
          },
          labelWidth: "130px",
          columns: [
            {
              prop: "id",
              hidden: true,
            },
            {
              label: "业务单号",
              type: "input",
              prop: "orderNo",
              span: 8,
              disabled: true,
            },
            {
              label: "门店",
              type: "storeInputDialog",
              prop: "storeId",
              data: [],
              disabled: false,
              isHasAll: true,
              // change: this.storeChange,
              span: 8,
            },
            {
              label: "供应商",
              type: "supplierInputDialog",
              prop: "supplierId",
              params: {type: 10},
              // data: [],
              span: 8,
              // change: this.supplierChange,
              rule: [
                {required: true, message: "请选择供应商", trigger: "change"},
              ],
            },
            {
              label: "单据金额",
              prop: "billAmount",
              type: "input",
              span: 8,
              disabled: true,
            },
            {
              label: "备注",
              type: "input",
              prop: "remarks",
              span: 8,
            },
          ],
        },
        // 表格字段
        listColumns: {
          height: this.height,
          summaryColumns: ["payAmount"],
          showSelect: true,
          disabled: false,
          columns: [
            {label: "序号", type: "index", width: 80, prop: "idx"},
            {
              label: "单据号",
              prop: "purchaseOrderNo",
              width: "180",
              align: "center",
              callback: this.goOrderDetail,
            },
            {
              label: "门店编码",
              prop: "storeCode",
              width: "120",
              align: "center",
            },
            {
              label: "门店名称",
              prop: "storeName",
              width: "90",
              align: "center",
            },
            {
              label: "单据类型",
              width: "90",
              prop: "type",
              align: "center",
              enumData: this.$utils.getCacheStatus("stSupplierBillMap.type"),
            },
            {
              label: "单据日期",
              width: "125",
              prop: "purchaseDttm",
              align: "center",
            },
            {
              label: "金额",
              width: "90",
              prop: "payAmount",
              align: "center",
            },
            {
              label: "备注",
              prop: "remarks",
              type: 'input',
              width: "200",
              align: "center",
            },
          ],
        },
        checkIndex: "",
        stockDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png',
            },
            right: '350px',
            top: '30px',
          },
          span: 8,
          labelWidth: '130',
          columns: [
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              span: 12,
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierName',
              span: 12,
            },
            {
              label: '仓库',
              type: 'select',
              prop: 'warehouseName',
              span: 12,
            },
            {
              label: '经手人',
              prop: 'handler',
              span: 12,
            },
            {
              label: '采购订单',
              prop: 'purchaseOrderNo',
              span: 12,
            },
            {
              label: '来货日期',
              prop: 'goodsArriveDttm',
              span: 12,
            },
            {
              label: '备注',
              prop: 'remarks',
              span: 12,
            },
          ],
          tablesProp: {
            pcGoodsMapList: {
              tableName: 'pcGoodsMapList',
              summaryColumns: ['retailPrice', 'salesAmount', 'buyPrice',
                'goodsNum', 'noStorageNum', 'giveGoodsNum', 'price',
                'discountRate', 'totalPrice', 'inventoryNum'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '150',
                  align: 'center',
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '90',
                  align: 'center',
                },
                {
                  label: '规格',
                  prop: 'specs',
                  width: '90',
                  align: 'center',
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: 'center',
                },
                {
                  label: '自编码',
                  width: '120',
                  prop: 'artNo',
                  align: 'center',
                },
                {
                  label: '档案零售价',
                  width: '120',
                  prop: 'retailPrice',
                  align: 'center',
                },
                {
                  label: '销售金额',
                  width: '90',
                  prop: 'salesAmount',
                  align: 'center',
                },
                {
                  label: '档案进价',
                  width: '90',
                  prop: 'buyPrice',
                  align: 'center',
                },
                {
                  label: '实际入库数量',
                  width: '130',
                  prop: 'goodsNum',
                  align: 'center',
                },
                {
                  label: '采购未入库数量',
                  width: '130',
                  prop: 'noStorageNum',
                  align: 'center',
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsNum',
                  align: 'center',
                },
                {
                  label: '价格',
                  width: '120',
                  prop: 'price',
                  align: 'center',
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  width: '120',
                  prop: 'totalPrice',
                  align: 'center',
                },
                {
                  label: '生产日期',
                  prop: 'produceDttm',
                  width: '220',
                  align: 'center',
                },
                {
                  label: '系统库存',
                  prop: 'inventoryNum',
                  width: '90',
                  align: 'center',
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: 'center',
                },
              ],
            },
          },
          // 打印的列表
          printTablesProp: {
            pcGoodsMapList: {
              tableName: 'pcGoodsMapList',
              showSummary: true,
              summaryColumns: ['totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '150',
                  align: 'center',
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '90',
                  align: 'center',
                },
                // {
                //   label: '规格',
                //   prop: 'specs',
                //   width: '90',
                //   align: 'center',
                // },
                {
                  label: '单位',
                  width: '60',
                  prop: 'unitName',
                  align: 'center',
                },
                // {
                //   label: '自编码',
                //   width: '120',
                //   prop: 'artNo',
                //   align: 'center',
                // },
                {
                  label: '零售价',
                  width: '120',
                  prop: 'retailPrice',
                  align: 'center',
                },
                {
                  label: '进货价',
                  width: '90',
                  prop: 'buyPrice',
                  align: 'center',
                },
                {
                  label: '实际入库数量',
                  width: '130',
                  prop: 'goodsNum',
                  align: 'center',
                },
                {
                  label: '采购未入库数量',
                  width: '130',
                  prop: 'noStorageNum',
                  align: 'center',
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsNum',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  width: '120',
                  prop: 'totalPrice',
                  align: 'center',
                },
              ],
            },
          },
          url: api.purchase.stock,
        },
        returnDetailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '350px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              span: 12,
              disabled: true
            }, {
              label: '供应商',
              type: 'select',
              prop: 'supplierName',
              span: 12,
            }, {
              label: '仓库名称',
              type: 'select',
              prop: 'warehouseName',
              span: 12,
            }, {
              label: '经手人',
              prop: 'handler',
              type: 'input',
              span: 12
            },
            {
              label: '收货单',
              type: 'select',
              prop: 'storageOrderNo',
              data: [],
              labelKey: 'orderNo',
              span: 12,
            },
            {
              label: '备注',
              type: 'input',
              prop: 'remarks',
              span: 12,
            }],
          tablesProp: {
            goodsMapList: {
              tableName: "goodsMapList",
              summaryColumns: ['retailPrice', 'salesAmount', 'buyPrice',
                'goodsNum', 'giveGoodsNum', 'price', 'totalPrice', 'inventoryNum'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '90',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '档案零售价',
                  prop: 'retailPrice',
                  align: "center"
                },
                {
                  label: '销售金额',
                  prop: 'salesAmount',
                  align: "center"
                },
                {
                  label: '档案进价',
                  prop: 'buyPrice',
                  align: "center"
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  align: "center",
                  change: this.numChange
                },
                {
                  label: '赠送数量',
                  prop: 'giveGoodsNum',
                  type: 'input',
                  align: "center"
                },
                {
                  label: '价格',
                  prop: 'price',
                  type: 'input',
                  align: "center",
                  change: this.priceChange
                },
                {
                  label: '小计金额',
                  prop: 'totalPrice',
                  type: 'input',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },
          // 打印的列表
          printTablesProp: {
            goodsMapList: {
              tableName: 'goodsMapList',
              showSummary: true,
              summaryColumns: ['retailPrice', 'salesAmount', 'buyPrice', 'goodsNum'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '90',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '档案零售价',
                  width: '100',
                  prop: 'retailPrice',
                  align: "center"
                },
                {
                  label: '销售金额',
                  prop: 'salesAmount',
                  align: "center"
                },
                {
                  label: '档案进价',
                  prop: 'buyPrice',
                  align: "center"
                },
                {
                  label: '退货数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  align: "center",
                  change: this.numChange
                },
              ],
            },
          },
          url: api.purchase.return
        }
      };
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.getStore(this.listFormOptions.columns);
      this.title = (this.$route.query.id ? "编辑" : "新增") + document.title;
      if (this.$route.query.id) {
        this.getDetail();
      }
    },
    methods: {
      //点击 高级搜索显示
      complexFunc() {
        this.complexShow = !this.complexShow;
      },
      listFormValueChange(value, column) {
        if (column.prop == "storeId") {
          this.$refs.listOperationForm.$refs.supplierInputDialog[0].initData();
          this.$refs.listOperationForm.formModel.supplierId = "";
          this.$refs.listOperationForm.formModel.storeId = value.id;
          this.$refs["listOperation"].clearTableData();
          this.listFormOptions.columns.filter(
            item => item.prop === "supplierId"
          )[0].params = {storeId: value.id, type: 10};
        }
        if (column.prop == "supplierId"){
          this.$refs["listOperation"].clearTableData();
        }
      },
      goOrderDetail(row) {
        if (row.type === 10) {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.stockDetailColumns);
          const {href} = this.$router.resolve({
            name: "stockDetail",
            query: {id: row.purchaseId},
          });
          window.open(href, "_blank");
        } else {
          this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.returnDetailColumns);
          const {href} = this.$router.resolve({
            name: "purchaseReturnDetail",
            query: {id: row.purchaseId},
          });
          window.open(href, "_blank");
        }

      },
      //编辑
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.settle.supplierBill + "?id=" + this.$route.query.id, {})
          .then((data) => {
            this.formModel = data.data;
            if (this.formModel.reviewerStatus === 10) {
              this.listFormOptions.disabled = true;
              this.listColumns.disabled = true;
            }
            this.loading = false;
            if (data.code === 200) {
              this.listFormOptions.columns.filter(
                (item) => item.prop === "supplierId"
              )[0].disabled = true;
              this.listFormOptions.columns.filter(
                (item) => item.prop === "storeId"
              )[0].disabled = true;
              //为头部表单赋值
              this.$refs.listOperationForm.formModel = data.data;
              if (data.data.storeId === null) {
                this.$refs.listOperationForm.formModel.storeId = "";
              }
              //为表格赋值
              this.$refs["listOperation"].addMoreRow(
                data.data.stSupplierBillMapMVOList,
                0
              );
              this.$nextTick(() => {
                this.$refs["listOperation"].selectAll();
              });
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch((err) => {
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      },

      //提交数据
      submitAuth(e) {
        //获取选择的list数据
        let tableList = this.$refs["listOperation"].selectRows;
        //将合计的值重新赋值给后端接收的参数
        let totalParam = this.$refs["listOperation"].getSumData();
        //将表头的值重新赋值给后端接收的参数
        let headParam = this.$refs.listOperationForm.getFormModel();
        headParam.reviewerStatus = 20;
        let searchParam = {
          ...{stSupplierBillMapList: tableList},
          ...totalParam,
          ...headParam,
        };
        if (tableList.length === 0) {
          this.$message({message: "请勾选数据！", type: "warning"});
        } else {
          if (tableList[tableList.length - 1].id !== undefined) {
            this.saveData(headParam, e, searchParam);
          } else {
            this.$message({message: "请勿勾选合计数据！", type: "warning"});
          }
        }
      },

      saveData(headParam, e, searchParam) {
        if (headParam.id) {
          if (e === 3) {
            this.$confirm("是否确认审核?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.handleRequest(
                  this.$axios.fetchPost(
                    api.settle.supplierBill + "/bill/audit",
                    searchParam
                  ),
                  e
                );
              })
              .catch(() =>
                this.$message({message: "审核取消！", type: "info"})
              );
          } else {
            this.$confirm("是否确认保存?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.handleRequest(
                  this.$axios.fetchPut(api.settle.supplierBill, searchParam),
                  e
                );
              })
              .catch(() =>
                this.$message({message: "保存取消！", type: "info"})
              );
          }
        } else {
          this.$confirm("是否确认保存?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.handleRequest(
                this.$axios.fetchPost(api.settle.supplierBill, searchParam),
                e
              );
            })
            .catch(() => this.$message({message: "保存取消！", type: "info"}));
        }
      },
      //处理添加和编辑的请求
      handleRequest(parm, e) {
        parm
          .then((data) => {
            this.loading = false;
            if (data.code === 200) {
              if (e === 3) {
                this.$notify({
                  type: "success",
                  title: '审核操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: "审核成功！", type: "success"});
                this.$router.push({path: "/bill/supplier"});
              } else {
                this.$notify({
                  type: "success",
                  title: '保存操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: "保存成功！", type: "success"});
                this.dialogShow = false;
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.reviewerStatus = data.data.reviewerStatus;
              }
            } else {
              if (e === 3) {
                this.$notify({
                  type: "error",
                  title: '审核操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: "审核失败！", type: "error"});
              } else {
                this.$notify({
                  type: "error",
                  title: '保存操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: "保存失败！", type: "error"});
              }
            }
          })
          .catch((err) => {
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      },

      //返回按钮事件
      beBack() {
        this.$router.go(-1);
      },
      refresh(e) {
        this.$router.go(0);
      },
      // 审核
      audit(e) {
        this.submitAuth(e);
      },
      //门店登录的时候是不可编辑的
      getStore(params) {
        let user = this.$utils.getSysUser();
        let deliverStoreId = params.filter((item) => item.prop === "storeId")[0];
        if (user.storeId) {
          deliverStoreId.disabled = true;
          deliverStoreId.defaultValue = user.storeId;
        } else {
          deliverStoreId.disabled = false;
          deliverStoreId.defaultValue = -1;
        }
      },
      //选择门店
      storeChange(form) {
        if (this.$refs["listOperation"]) {
          this.$refs["listOperation"].clearTableData();
        }
        if (form.storeId) {
          this.$axios.fetchPost(api.archives.supplier + "/query/supplier/list", {
            storeId: form.storeId,
            type: 10,
          }).then((data) => {
            if (data.code === 200) {
              form.supplierId = '';
              this.listFormOptions.columns.filter((item) => item.prop === "supplierId")[0].data = data.data;
            } else {
              this.$message({message: "门店获取供应商失败", type: "error"});
            }
          });
        }
      },
      // 选择供应商
      supplierChange() {
        let form = this.$refs.listOperationForm.getFormModel();
        if (!form.storeId) {
          this.$message.warning("请选择门店");
          return;
        }
        if (!form.supplierId) {
          this.$message.warning("请选择供应商")
          return;
        }
        if (form.supplierId) {
          const loading = this.$loading({
            lock: true,
            text: '数据加载中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)',
          });
          this.$refs["listOperation"].clearTableData();
          let queryParams = {storeId: form.storeId, supplierId: form.supplierId};
          this.$axios.fetchPost(api.settle.supplierPurchaseOrder, queryParams).then((data) => {
            if (data.code === 200) {
              if (data.data.length > 0) {
                //为表格赋值
                data.data.map((item, index) => {
                  item.id = index + 1;
                });
                this.$refs["listOperation"].addMoreRow(data.data, 0);
              } else {
                this.$message({message: "此供应商无单据数据", type: "warning"});
              }
            } else {
              this.$message({message: "供应商获取采购单失败", type: "error"});
            }
          }).finally(() => {
            loading.close()
          });
        }
      },
      selectShowChange(selectRows) {
        let billAmount = 0;
        selectRows.map((item) => {
          billAmount = billAmount + parseFloat(item.payAmount);
        });
        this.$refs.listOperationForm.formModel.billAmount = billAmount.toFixed(2);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/page/settle/supplier/SupplierBillAdd.vue